// extracted by mini-css-extract-plugin
export default {"page":"LandingPage_page__T-b4p","hero":"LandingPage_hero__HVgjl","orbLogo":"LandingPage_orbLogo__+89Jc"};